import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { catalogService } from '../../shared/services';
import { Search, BookOpen, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

export function CatalogPage() {
  const [search, setSearch] = useState('');
  const [categoria, setCategoria] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['cursos', search, categoria],
    queryFn: () => catalogService.getCursos({ search, categoria }),
  });

  const categorias = ['Financeiro', 'Fiscal', 'Compras', 'Contabilidade', 'RH', 'Vendas'];

  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Catálogo de Cursos</h1>
          <p className="text-gray-600 mt-2">Explore nossos cursos e trilhas de aprendizado</p>
        </div>

        {/* Filtros */}
        <div className="card mb-8">
          <div className="flex flex-col md:flex-row gap-4">
            {/* Busca */}
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="text"
                placeholder="Buscar cursos..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
            </div>

            {/* Categoria */}
            <select
              value={categoria}
              onChange={(e) => setCategoria(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            >
              <option value="">Todas as categorias</option>
              {categorias.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Lista de cursos */}
        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              {data && Array.isArray(data) && data.map((curso) => (
                <Link
                  key={curso.id}
                  to={`/cursos/${curso.slug}`}
                  className="card hover:shadow-md transition-shadow group"
                >
                  <div className="bg-gray-100 rounded-lg overflow-hidden mb-4 aspect-video">
                    {curso.capaUrl ? (
                      <img
                        src={curso.capaUrl}
                        alt={curso.titulo}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <BookOpen size={48} className="text-gray-400" />
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded">
                      {curso.categoria}
                    </span>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {curso.titulo}
                  </h3>
                  
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                    {curso.descricao}
                  </p>
                  
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <div className="flex items-center gap-1">
                      <Clock size={16} />
                      <span>{curso.cargaHorariaMin} min</span>
                    </div>
                    {curso.progresso !== undefined && (
                      <div className="flex items-center gap-1">
                        <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                          <div
                            className="h-full bg-primary-600"
                            style={{ width: `${curso.progresso.percentual}%` }}
                          />
                        </div>
                        <span>{curso.progresso.percentual}%</span>
                      </div>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
